import { Link } from "react-router-dom";
import { Box, Button, Typography } from "@mui/material";

import { cartSummary } from "@/utils/staticData/cartSummary";
import { ROUTES } from "@/utils/navigation";

interface IProps {
  totalAmount: number;
}
const CartSummary: React.FC<IProps> = ({ totalAmount }) => {
    const newTotalAmount = totalAmount % 1 === 0 ? totalAmount : totalAmount.toFixed(2);

    return (
    <>
      <Box
        display="flex"
        flexDirection="column"
        gap={{ xs: 2, md: 3 }}
        mb={{ xs: 4, md: 5 }}
      >
        {cartSummary.map(({ label, value }, index) => (
          <Box
            key={index}
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography variant="subtitle1" fontWeight={{ xs: 600, md: 500 }}>
              {label}
            </Typography>
            <Typography variant="subtitle1" fontWeight={{ xs: 600, md: 500 }}>
              {value}
            </Typography>
          </Box>
        ))}

        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h4" fontSize={{ xs: "1.125rem", md: "1.25rem" }}>
            Total (USD)
          </Typography>
          <Typography variant="h4" fontSize={{ xs: "1.125rem", md: "1.25rem" }}>
            ${newTotalAmount}
          </Typography>
        </Box>
      </Box>

      <Button
        component={Link}
        to={`${ROUTES.checkout}`}
        variant="contained"
        fullWidth
      >
        Checkout
      </Button>
    </>
  );
};

export default CartSummary;
